module.exports = __webpack_public_path__ + "img/essex.7219fa70.jpg";